if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"group_mfe_identity","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return 108 != chunkId},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}